import React from "react";
import { useTranslation } from "react-i18next";

import { LogoType } from "../../../../commons/types/logo";
import * as icons from "../../../../resources/icons";
import Button from "../../../commons/components/Button/Button";
import FlexLayout from "../../../commons/components/FlexLayout/FlexLayout";
import Headline from "../../../commons/components/Headline/Headline";
import Icon from "../../../commons/components/Icon/Icon";
import IconButton from "../../../commons/components/IconButton/IconButton";
import Modal from "../../../commons/components/Modal/Modal";
import Paragraph from "../../../commons/components/Paragraph/Paragraph";
import Logo from "../../../commons/container/App/LogoPartial";
import { useAppHistory } from "../../../commons/libs/hooks/use-app-routing";
import { ROUTES } from "../../../commons/routes";
import { deleteLicense, reloadApp } from "../../libs/credentials";
import { useMobileAppDispatcher } from "../../store/hooks";

interface Props {
  nodeRef?: React.Ref<HTMLElement>;
}

const AboutModalPartial = ({ nodeRef }: Props) => {
  const { t } = useTranslation(["mobile"]);
  const [dispatch, actions] = useMobileAppDispatcher();
  const history = useAppHistory();

  const year = React.useMemo(() => new Date().getFullYear(), []);

  return (
    <Modal
      nodeRef={nodeRef}
      closeButton={
        <IconButton onClick={() => dispatch(actions.modal.close())} icon={<Icon source={icons.IconSmallCross} />} />
      }
      footer={
        <FlexLayout gap="l" justifyContent="center">
          <Button
            onClick={() => {
              dispatch(actions.modal.showModal("legalInformation"));
            }}
          >
            {t("mobile:aboutModal.legalInformation")}
          </Button>
          <Button
            onClick={() => {
              dispatch(actions.modal.close());
              history.push(ROUTES.DEVICE_INFORMATION_AND_SUPPORT.INDEX);
            }}
          >
            {t("mobile:aboutModal.support")}
          </Button>
          <Button
            onClick={async () => {
              dispatch(actions.modal.close());
              try {
                await deleteLicense();
              } catch (error) {
                console.error("Error during logout:", error);
              } finally {
                reloadApp();
              }
            }}
          >
            {t("mobile:aboutModal.logout")}
          </Button>
        </FlexLayout>
      }
    >
      <Headline kind="sub">{t("mobile:aboutModal.headline")}</Headline>
      <Logo type={LogoType.ClaimSmall} />
      <Headline>{t("mobile:defaults.appName")}</Headline>
      <Paragraph kind="support" classNames={["u-space-top-base"]}>
        {t("mobile:aboutModal.copyright")} {year} {t("mobile:defaults.companyName")}
        <br />
        {t("mobile:aboutModal.allRightsReserved")}
      </Paragraph>
    </Modal>
  );
};

export default AboutModalPartial;
